import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Link, withRouter } from 'react-router-dom';
import { axiosInstance } from '@appblocks/frontend/client/utils';
import EditableLabel from '@appblocks/frontend/client/Components/EditableLabel';
import ModelSelect from '@appblocks/frontend/cloudclient/Components/ModelSelect';
import { confirm as confirmDialog } from 'react-bootstrap-confirmation';

const store = require('@appblocks/frontend/redux/store').default;

const DeviceGroupSettingsView = ({
    group,
    getGroup,
    deleteGroup,
    ...props
}) => {
    const [isApplicationEditing, setIsApplicationEditing] = useState(false);
    const [updatedAppId, setUpdatedAppId] = useState(undefined);
    const [updatedVersion, setUpdatedVersion] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const updateGroup = async (params) => {
        setLoading(true);
        try {
            await axiosInstance.put(`${process.env.API_URL}/cgg/groups/${group._id}`, {
                ...group,
                ...params,
            });
            getGroup();
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const changeApplication = async () => {
        if (!await confirmDialog(`Changing the application will remove incompatible delegated settings and tables from the group. 

After changing the application a manual firmware update will be required for the devices to be in sync.

Are you sure you want to continue?`)) {
            return;
        }
        await updateGroup({
            project: updatedAppId,
            version: updatedVersion,
        });
        setIsApplicationEditing(false);
        setUpdatedAppId(undefined);
        setUpdatedVersion(undefined);
    };

    return (
        <>
            <Form className="mt-3 col-md-6">
                <Form.Group className="mb-3">
                    <div
                        className="d-inline-block"
                    >
                        <EditableLabel
                            onSave={(newName) => {
                                updateGroup({ name: newName });
                            }}
                            text={group.name}
                            asProps={{
                                type: 'text',
                                value: group.name,
                                readOnly: true,
                            }}
                        >
                            <h4>
                                {group.name}
                            </h4>
                        </EditableLabel>
                    </div>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        <small className="text-secondary">
                            Application
                        </small>
                    </Form.Label>
                    <br />
                    <>
                        {
                            isApplicationEditing ? (
                                <div className="d-flex flex-column">
                                    <ModelSelect
                                        model="projects"
                                        onChange={(selected) => {
                                            setUpdatedAppId(selected);
                                            setTimeout(() => {
                                                setUpdatedVersion(undefined);
                                            }, 0);
                                        }}
                                        value={updatedAppId}
                                        className="col-md-8 mb-2"
                                    />
                                    {
                                        updatedAppId && (
                                            <ModelSelect
                                                model="versions"
                                                apiRoute={`/api/projects/${updatedAppId}/versions`}
                                                onChange={value => setUpdatedVersion(value)}
                                                nameProperty="versionCode"
                                                value={updatedVersion}
                                                className="col-md-8 mb-2"
                                            />
                                        )
                                    }
                                    <div>
                                        <Button
                                            disabled={!updatedAppId || !updatedVersion || loading}
                                            variant="primary"
                                            className="me-2"
                                            onClick={changeApplication}
                                        >
                                            Change Application
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            onClick={() => {
                                                setIsApplicationEditing(false);
                                                setUpdatedAppId(undefined);
                                                setUpdatedVersion(undefined);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="w-100 d-flex flew-row align-items-center"
                                >
                                    <div>
                                        {group.project ? group.project.name : ''}
                                        &nbsp;
                                        {`(${group.projectVersion ? group.projectVersion.versionCode : 'latest'})`}
                                    </div>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="ms-2"
                                        onClick={() => setIsApplicationEditing(true)}
                                    >
                                        Edit
                                    </Button>
                                </div>
                            )
                        }
                    </>
                </Form.Group>
            </Form>
            <hr />
            <div className="d-flex">
                <Button
                    className="mb-3 ms-1"
                    variant="danger"
                    onClick={deleteGroup}
                    size="sm"
                >
                    Delete Group
                </Button>
            </div>
        </>
    );
};

export default withRouter(DeviceGroupSettingsView);
